// Section 8 Options Definitions
// These will eventually come from an admin panel/API

export const MODSZERTANI_OPTIONS = {
    hu: [
        { value: 'tobb_projektmunka', label: 'Több projektmunka bevezetése' },
        { value: 'blended_learning', label: 'Blended learning bővítése' },
        { value: 'forditott_osztaly', label: 'Fordított osztályterem (Flipped Classroom)' },
        { value: 'aszinkron_oktatas', label: 'Aszinkron oktatás lehetősége' },
        { value: 'gamification', label: 'Gamification elemek alkalmazása' },
        { value: 'esettanulmany', label: 'Esettanulmány-alapú tanulás' },
        { value: 'problema_alapu', label: 'Probléma-alapú tanulás (PBL)' },
        { value: 'peer_learning', label: 'Peer learning erősítése' },
        { value: 'digitalis_eszkozok', label: 'Digitális eszközök szélesebb körű használata' },
        { value: 'nincs_tervezett', label: 'Nincs tervezett módszertani változás' },
        { value: 'egyeb', label: 'Egyéb' }
    ],
    en: [
        { value: 'tobb_projektmunka', label: 'Introduction of increased project-based work' },
        { value: 'blended_learning', label: 'Expansion of blended learning' },
        { value: 'forditott_osztaly', label: 'Application of the flipped classroom approach' },
        { value: 'aszinkron_oktatas', label: 'Option for asynchronous learning' },
        { value: 'gamification', label: 'Introduction of gamification elements' },
        { value: 'esettanulmany', label: 'Case study-based learning' },
        { value: 'problema_alapu', label: 'Problem-based learning (PBL)' },
        { value: 'peer_learning', label: 'Strengthening of peer learning' },
        { value: 'digitalis_eszkozok', label: 'Broader use of digital tools' },
        { value: 'nincs_tervezett', label: 'No planned methodological changes' },
        { value: 'egyeb', label: 'Other' }
    ]
};

export const PROJEKTFELADATOK_OPTIONS = {
    hu: [
        { value: 'tobb_kotelezo', label: 'Igen, több tantárgyban is előfordul' },
        { value: 'van_kotelezo', label: 'Igen, 1-2 kötelező projektfeladatos tantárgy' },
        { value: 'csak_valaszthato', label: 'Igen, csak választható projektfeladatos tantárgyak' },
        { value: 'tervezes_alatt', label: 'Tervezés alatt van' },
        { value: 'nincs_projekt', label: 'Nincs projektfeladatos tantárgy' }
    ],
    en: [
        { value: 'tobb_kotelezo', label: 'Yes, several compulsory courses include project-based assignments' },
        { value: 'van_kotelezo', label: 'Yes, 1–2 compulsory courses include project-based assignments' },
        { value: 'csak_valaszthato', label: 'Yes, project-based assignments are included only in elective courses' },
        { value: 'tervezes_alatt', label: 'Under development' },
        { value: 'nincs_projekt', label: 'No courses with project-based assignments' }
    ]
};

export const TANTARGYAK_SZAMA_OPTIONS = {
    hu: [
        { value: 'egy_ket_tantargy', label: '1-2 tantárgy' },
        { value: 'harom_ot_tantargy', label: '3-5 tantárgy' },
        { value: 'hat_tiz_tantargy', label: '6-10 tantárgy' },
        { value: 'tiz_plus_tantargy', label: '10+ tantárgy' },
        { value: 'nincs_szam', label: 'Nincs' }
    ],
    en: [
        { value: 'egy_ket_tantargy', label: '1-2 courses' },
        { value: 'harom_ot_tantargy', label: '3-5 courses' },
        { value: 'hat_tiz_tantargy', label: '6-10 courses' },
        { value: 'tiz_plus_tantargy', label: '10+ courses' },
        { value: 'nincs_szam', label: 'None' }
    ]
};

export const PROJEKT_TEMA_FORRAS_OPTIONS = {
    hu: [
        { value: 'kulso_partnerek', label: 'Külső partnerek működéséből' },
        { value: 'oktatok_altal', label: 'Oktatók által meghatározott témák' },
        { value: 'hallgatok_altal', label: 'Hallgatók által javasolt témák' },
        { value: 'aktualis_iparagi', label: 'Aktuális iparági kihívások' },
        { value: 'kutatasi_temak', label: 'Kutatási témákhoz kapcsolódó' },
        { value: 'vegyes', label: 'Vegyes' },
        { value: 'egyeb', label: 'Egyéb' }
    ],
    en: [
        { value: 'kulso_partnerek', label: 'Assignments commissioned by external partners' },
        { value: 'oktatok_altal', label: 'Topics defined by teaching staff' },
        { value: 'hallgatok_altal', label: 'Topics proposed by students' },
        { value: 'aktualis_iparagi', label: 'Current industry challenges' },
        { value: 'kutatasi_temak', label: 'Linked to research topics' },
        { value: 'vegyes', label: 'Mixed' },
        { value: 'egyeb', label: 'Other' }
    ]
};

export const MI_TARTALMAK_OPTIONS = {
    hu: [
        { value: 'dedikalt_mi', label: 'Dedikált MI tantárgy' },
        { value: 'mi_modul', label: 'MI modul/specializáció' },
        { value: 'mi_integralt', label: 'MI tartalmak más tantárgyakba integrálva' },
        { value: 'mi_eszkozok', label: 'MI eszközök használata (ChatGPT, GitHub Copilot stb.)' },
        { value: 'mi_alkalmazasok', label: 'MI alkalmazások szakmai kontextusban' },
        { value: 'mi_etikai', label: 'MI etikai kérdések' },
        { value: 'nincs_mi', label: 'Nincs MI-hoz kapcsolódó tartalom' },
        { value: 'egyeb', label: 'Egyéb' }
    ],
    en: [
        { value: 'dedikalt_mi', label: 'Dedicated AI course' },
        { value: 'mi_modul', label: 'AI module / specialisation' },
        { value: 'mi_integralt', label: 'AI content integrated into other courses' },
        { value: 'mi_eszkozok', label: 'Use of AI tools (e.g. ChatGPT, GitHub Copilot, etc.)' },
        { value: 'mi_alkalmazasok', label: 'AI applications in a professional context' },
        { value: 'mi_etikai', label: 'Ethical aspects of AI' },
        { value: 'nincs_mi', label: 'No AI-related content' },
        { value: 'egyeb', label: 'Other' }
    ]
};

export const KULSO_PARTNER_OPTIONS = {
    hu: [
        { value: 'tobb_kulso_kapcsolat', label: 'Igen, több külső szakmai kapcsolat' },
        { value: 'egy_ket_jelentős', label: 'Igen, egy-két jelentős partner' },
        { value: 'alkalomszeru', label: 'Alkalomszerű együttműködések' },
        { value: 'nincs_kiemelkedő', label: 'Nincs kiemelkedő partneri kapcsolat' }
    ],
    en: [
        { value: 'tobb_kulso_kapcsolat', label: 'Yes, multiple external partnerships' },
        { value: 'egy_ket_jelentős', label: 'Yes, one or two significant partners' },
        { value: 'alkalomszeru', label: 'Occasional collaborations' },
        { value: 'nincs_kiemelkedő', label: 'No significant partnerships' }
    ]
};

export const SZAKKEPZESI_MEGALLAPODAS_OPTIONS = {
    hu: [
        { value: 'tobb_aktiv_megallapodas', label: 'Igen, több aktív megállapodás' },
        { value: 'egy_ket_megallapodas', label: 'Igen, egy-két megállapodás' },
        { value: 'tervezes_alatt_szakkepzes', label: 'Tervezés alatt van' },
        { value: 'nincs_szakkepzesi', label: 'Nincs szakképzési együttműködés' }
    ],
    en: [
        { value: 'tobb_aktiv_megallapodas', label: 'Yes, several active agreements' },
        { value: 'egy_ket_megallapodas', label: 'Yes, one or two agreements' },
        { value: 'tervezes_alatt_szakkepzes', label: 'Under development' },
        { value: 'nincs_szakkepzesi', label: 'No VET collaboration' }
    ]
};

export const KREDITBESZAMITAS_OPTIONS = {
    hu: [
        { value: 'van_kreditbeszamitas', label: 'Van kreditbeszámítási rendszer' },
        { value: 'tervezes_alatt_kredit', label: 'Tervezés alatt van' },
        { value: 'nincs_kreditbeszamitas', label: 'Nincs kreditbeszámítás' }
    ],
    en: [
        { value: 'van_kreditbeszamitas', label: 'Credit transfer system in place' },
        { value: 'tervezes_alatt_kredit', label: 'Under development' },
        { value: 'nincs_kreditbeszamitas', label: 'No credit transfer' }
    ]
};

export const DUALIS_KEPZES_OPTIONS = {
    hu: [
        { value: 'aktiv_dualis', label: 'Igen, aktív duális képzési program' },
        { value: 'alacsony_reszvetel', label: 'Igen, de alacsony hallgatói részvétellel' },
        { value: 'tervezes_alatt_dualis', label: 'Tervezés alatt van' },
        { value: 'nem_mukodik_dualis', label: 'Nem működik duális képzés' }
    ],
    en: [
        { value: 'aktiv_dualis', label: 'Yes, an active dual education and training programme' },
        { value: 'alacsony_reszvetel', label: 'Yes, but with low student participation' },
        { value: 'tervezes_alatt_dualis', label: 'Under development' },
        { value: 'nem_mukodik_dualis', label: 'No dual education and training programme implemented' }
    ]
};

export const AACSB_LEARNING_GOALS_OPTIONS = {
    hu: [
        { value: 'lg1_kommunikacio', label: 'LG1 – Kommunikáció' },
        { value: 'lg2_elemzokeszseg', label: 'LG2 – Elemzőkészség' },
        { value: 'lg3_etikus', label: 'LG3 – Etikus és felelős gondolkodás' },
        { value: 'lg4_szakmai_tudas', label: 'LG4 – Szakmai tudás és alkalmazás' },
        { value: 'lg5_nemzetkozi', label: 'LG5 – Nemzetközi és interkultúrális kompetenciák' },
        { value: 'nem_tortent', label: 'Nem történt AoL mérés a félévben' }
    ],
    en: [
        { value: 'lg1_kommunikacio', label: 'LG1 – Communication' },
        { value: 'lg2_elemzokeszseg', label: 'LG2 – Analytical Skills' },
        { value: 'lg3_etikus', label: 'LG3 – Ethical and Responsible Thinking' },
        { value: 'lg4_szakmai_tudas', label: 'LG4 – Professional Knowledge and Application' },
        { value: 'lg5_nemzetkozi', label: 'LG5 – International and Intercultural Competencies' },
        { value: 'nem_tortent', label: ' No AoL assessment was conducted during the semester' }
    ]
};

export const ABET_STUDENT_OUTCOMES_OPTIONS = {
    hu: [
        { value: 'so1_mernoki_problema', label: 'SO1 – Mérnöki problémamegoldás (problem solving)' },
        { value: 'so2_mernoki_tervezes', label: 'SO2 – Mérnöki tervezés (design) meghatározott igényekre, korlátokkal..' },
        { value: 'so3_hatekony_kommunikacio', label: 'SO3 – Hatékony kommunikáció (írásban/szóban)' },
        { value: 'so4_etikai_szakmai', label: 'SO4 – Etikai és szakmai felelősség, döntések társadalmi/ környezeti hatása' },
        { value: 'so5_csapatmunka', label: 'SO5 – Csapatmunka és vezetés, közös célok elérése' },
        { value: 'so6_kiserletezos', label: 'SO6 – Kísérletezés / adatgyűjtés / elemzés és következtetés' },
        { value: 'so7_elethoszszig', label: 'SO7 – Élethosszig tartó tanulás, önálló fejlődés' },
        { value: 'nem_tortent_so', label: 'Nem történt SO mérés a félévben' }
    ],
    en: [
        { value: 'so1_mernoki_problema', label: 'SO1 – Engineering Problem Solving' },
        { value: 'so2_mernoki_tervezes', label: 'SO2 – Engineering design to meet specified needs and constraints' },
        { value: 'so3_hatekony_kommunikacio', label: 'SO3 – Effective communication (written and oral)' },
        { value: 'so4_etikai_szakmai', label: 'SO4 – Ethical and professional responsibility; societal and environmental impact of decisions' },
        { value: 'so5_csapatmunka', label: 'SO5 – Teamwork and leadership in achieving common goals' },
        { value: 'so6_kiserletezos', label: 'SO6 – Experimentation / data collection / analysis and interpretation' },
        { value: 'so7_elethoszszig', label: 'SO7 – Lifelong learning and independent professional development' },
        { value: 'nem_tortent_so', label: 'No Student Outcome assessment was conducted during the semester' }
    ]
};

export const MERESI_EREDMENYEK_OPTIONS = {
    hu: [
        { value: 'target_met', label: 'Target (cél) teljesült (target met)' },
        { value: 'partially_met', label: 'Részben teljesült (partially met)' },
        { value: 'not_met', label: 'Nem teljesült (not met)' },
        { value: 'nem_relevans', label: 'Nem releváns (nem volt mérés)' }
    ],
    en: [
        { value: 'target_met', label: 'Target met' },
        { value: 'partially_met', label: 'Partially met' },
        { value: 'not_met', label: 'Not met' },
        { value: 'nem_relevans', label: 'Not applicable (no assessment conducted)' }
    ]
};

export const TELJESITMENYBELI_KIHIVASOK_OPTIONS = {
    hu: [
        { value: 'elmeleti_tudas', label: 'Elméleti tudás mélysége' },
        { value: 'gyakorlati_alkalmazas', label: 'Gyakorlati alkalmazás' },
        { value: 'kritikai_gondolkodas', label: 'Kritikai gondolkodás' },
        { value: 'kommunikacio_prezentacio', label: 'Kommunikáció / prezentáció' },
        { value: 'irasbeli_keszsegek', label: 'Írásbeli készségek' },
        { value: 'csapatmunka', label: 'Csapatmunka' },
        { value: 'digitalis_keszsegek', label: 'Digitális készségek' },
        { value: 'etikai_erzekenyesg', label: 'Etikai érzékenység' },
        { value: 'nemzetkozi_szemlelet', label: 'Nemzetközi szemlélet' },
        { value: 'egyeb', label: 'Egyéb' }
    ],
    en: [
        { value: 'elmeleti_tudas', label: 'Depth of theoretical knowledge' },
        { value: 'gyakorlati_alkalmazas', label: 'Practical application' },
        { value: 'kritikai_gondolkodas', label: 'Critical thinking' },
        { value: 'kommunikacio_prezentacio', label: 'Communication / presentation skills' },
        { value: 'irasbeli_keszsegek', label: 'Written skills' },
        { value: 'csapatmunka', label: 'Teamwork' },
        { value: 'digitalis_keszsegek', label: 'Digital skills' },
        { value: 'etikai_erzekenyesg', label: 'Ethical sensitivity' },
        { value: 'nemzetkozi_szemlelet', label: 'International perspective' },
        { value: 'egyeb', label: 'Other' }
    ]
};

export const FEJLESZTESI_JAVASLATOK_OPTIONS = {
    hu: [
        { value: 'tananyag_modositasa', label: 'Tananyag módosítása' },
        { value: 'ertekelesi_modszer', label: 'Értékelési módszer módosítása' },
        { value: 'gyakorlati_peldak', label: 'További gyakorlati példák / projektek beépítése' },
        { value: 'oktatok_egyetertese', label: 'Oktatók közötti egyetértések erősítése' },
        { value: 'hallgatoi_tamogatas', label: 'Hallgatói támogatás növelése (konzultációk, segédanyagok)' },
        { value: 'tanulasi_kimenetek', label: 'Új tanulási kimenetek pontosítása' },
        { value: 'egyeb', label: 'Egyéb javaslat' }
    ],
    en: [
        { value: 'tananyag_modositasa', label: 'Modification of teaching materials' },
        { value: 'ertekelesi_modszer', label: 'Revision of assessment methods' },
        { value: 'gyakorlati_peldak', label: 'Integration of additional practical examples / projects' },
        { value: 'oktatok_egyetertese', label: 'Strengthening coordination among teaching staff' },
        { value: 'hallgatoi_tamogatas', label: 'Enhancement of student support (consultations, support materials)' },
        { value: 'tanulasi_kimenetek', label: 'Clarification and refinement of learning outcomes' },
        { value: 'egyeb', label: 'Other recommendation:' }
    ]
};
